export default "__VITE_ASSET__BshBtNYr__"